import React, { useState } from 'react';
import { Row, Col, Form, Input, message, Button } from 'antd';
// , notification
// import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import styles from './index.module.less';
import { Message, Icon } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import Logo from '@/common/assets/images/LoginPage1.png';
// import SuccessMessage from '@/common/assets/images/successmessage.svg';
// import martrimonyLogo from '@/common/assets/icons/logo.svg';
import martrimonyLogo from '@/common/assets/images/LogoHeaer.png';
import { LoadingOutlined } from '@ant-design/icons';
import { get_generateOTP } from '../../redux/slice';

import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
// import { CheckCircleOutlined } from '@ant-design/icons';

const LoginPage = ({ loading, onSubmit, otploading }) => {
  const [errorMsg] = useState('');

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  // const [otp, setOtp] = useState(true);
  const [otpGenerated, setOtpGenerated] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '']);

  const generateOTP = async (formValues) => {
    const { user_name } = formValues;
    let payload = { user_name };
    // const payload = JSON.stringify({ user_name });

    console.log('payload_otp', payload);

    try {
      const response = await dispatch(get_generateOTP(payload)).unwrap();

      if (response.success === true) {
        setOtpGenerated(true);
        setOtp(['', '', '', '']);
        message.success('OTP sent successfully!');
        // message.success({
        //   content: 'OTP sent successfully!',
        //   duration: 3,
        //   icon: <CheckCircleOutlined style={{ color: 'green' }} /> // Force green tick
        // });
      } else {
        setOtpGenerated(false);
        message.error(
          response.message || 'Failed to generate OTP. Please try again.'
        );
      }
    } catch (error) {
      setOtpGenerated(false);
      message.error(
        error.message ||
          'An error occurred while generating OTP. Please try again.'
      );
    }
  };

  // const handleChange = (value, index) => {
  //   console.log('Input value:', value);
  //   setOtp((prevOtp) => {
  //     const newOtp = [...prevOtp];
  //     newOtp[index] = value;
  //     // Ensure the form stays updated with the latest OTP value
  //     form.setFieldsValue({ otp: newOtp.join('') });
  //     console.log('Updated OTP array:', newOtp);
  //     // Auto-focus to the next box if value is entered
  //     if (value && index < 3) {
  //       document.getElementById(`otp-${index + 1}`).focus();
  //     }
  //     return newOtp;
  //   });
  // };
  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return; // Only allow numbers

    setOtp((prevOtp) => {
      const newOtp = [...prevOtp];
      newOtp[index] = value;

      form.setFieldsValue({ otp: newOtp.join('') });

      if (value && index < 3) {
        document.getElementById(`otp-${index + 1}`).focus();
      }

      console.log('Updated OTP:', newOtp);

      // ✅ Ensure the form submits when 4 digits are entered
      if (
        newOtp.every((digit) => digit !== '') &&
        newOtp.join('').length === 4
      ) {
        console.log('Submitting Form:', newOtp.join(''));
        setTimeout(() => form.submit(), 100); // 🔥 Add delay to allow re-render
      }

      return newOtp;
    });
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  // const onFinish = (values) => {
  //   const { user_name, otp } = values;
  //   let payload = {
  //     user_name,
  //     otp
  //   };
  //   onSubmit(payload);
  // };

  // const onFinish = (values) => {
  //   // console.log('values', values);
  //   const { user_name } = values;
  //   // const otpValue = otp.join(''); // Combine OTP array to a string
  //   // let payload = { user_name, otp: otpValue };
  //   // onSubmit(payload);
  //   const otpValue = otp.join('');
  //   if (otpValue.length === 4) {
  //     // console.log('Submitting with OTP:', { ...values, otp: otpValue });
  //     let payload = { user_name, otp: otpValue };
  //     // console.log('payload', payload);
  //     onSubmit(payload, otp);
  //   }
  // };

  const onFinish = (values) => {
    console.log('Form submission triggered:', values);
    const { user_name } = values;
    const otpValue = otp.join('');
    if (otpValue.length === 4) {
      // console.log('Submitting with OTP:', { user_name, otp: otpValue });
      onSubmit({ user_name, otp: otpValue });
    } else {
      message.error('OTP must be 4 digits.');
    }
  };

  const customLoader = <LoadingOutlined style={{ color: '#faf1d9' }} spin />;

  // const duration = 10; // Change duration here

  // notification.success({
  //   key: 'unique_notification', // Ensures only one notification is shown
  //   message: (
  //     <span
  //       style={{ color: '#FF6403', fontWeight: 'bold', marginRight: '10px' }}
  //     >
  //       Congratulations!
  //     </span>
  //   ),
  //   description: (
  //     <div>
  //       <p
  //         style={{
  //           color: '#FF6403',
  //           display: 'flex',
  //           alignItems: 'center',
  //           gap: '10px',
  //           whiteSpace: 'nowrap', // 🔸 No wrapping
  //           overflow: 'hidden', // 🔸 Hide overflow
  //           textOverflow: 'ellipsis', // 🔸 Add ellipsis if too long
  //           marginBottom: '8px'
  //         }}
  //       >
  //         Your account has been successfully created. Start your journey to find
  //         your perfect match today.
  //       </p>
  //       {/* Progress Bar */}
  //       <div
  //         style={{
  //           height: '3px',
  //           backgroundColor: '#FF6403',
  //           position: 'absolute',
  //           bottom: '5px',
  //           left: 0,
  //           width: '100%',
  //           animation: `progress-bar ${duration}s linear forwards`
  //         }}
  //       />
  //       <style>
  //         {`
  //         @keyframes progress-bar {
  //           from { width: 100%; }
  //           to { width: 0%; }
  //         }
  //         `}
  //       </style>
  //     </div>
  //   ),
  //   duration: duration, // Matches progress bar
  //   placement: 'top',
  //   style: {
  //     background: 'linear-gradient(to right, #fff3e0, #ffe0b2)',
  //     borderRadius: '10px',
  //     // width: '410px',
  //     width: '100%',
  //     position: 'relative',
  //     paddingBottom: '15px'
  //   },
  //   icon: (
  //     <img
  //       src={SuccessMessage}
  //       alt="success"
  //       style={{ width: 30, marginRight: '10px' }}
  //     />
  //   ),
  //   closeIcon: (
  //     <span
  //       style={{ fontSize: '14px', color: '#FF6403', cursor: 'pointer' }}
  //       onClick={() => notification.destroy()}
  //     >
  //       ❌
  //     </span>
  //   )
  // });

  return (
    <>
      <Row className={styles.mainContainerStyle}>
        {/* <Col xs={24} xl={8} md={12} sm={12} className={styles.backgroundImg}>
          <img className={`${styles.left_logo}`} src={Logo} />
        </Col> */}
        <Col
          xs={24}
          xl={11}
          md={24}
          sm={24}
          lg={24}
          className={styles.backgroundImg}
        >
          <img className={`${styles.left_logo}`} src={Logo} />
        </Col>

        {/* <Col xs={18} xl={16} sm={18} md={12} className={styles.sideheader}> */}
        <Col
          xs={24}
          xl={13}
          sm={24}
          md={24}
          lg={24}
          className={styles.sideheader}
        >
          <div className={styles.headerload}>
            <img
              src={martrimonyLogo}
              alt="matrimony logo"
              className={styles.logostyles}
            />
          </div>
          <div className={styles.sideheader1}>
            <h1 className={styles.headingsmall}>Ready to meet</h1>
            <h1 className={styles.someonestyles}>SOMEONE</h1>
            <h1 className={styles.someonestyles}>WHO GETS YOU?</h1>
          </div>
          {/* <div className={styles.successalert}>
            <h5>Congratulations!</h5>
            <p style={{ color: '#FF6403' }}>
              Your account has been successfully created. Start your journey to
              find your perfect match today.
            </p>
          </div> */}
          &nbsp;
          <br />
          <div className={styles.right_outer_container}>
            <Form
              form={form}
              layout="vertical"
              className={`ant-form ant-form-vertical mt-4 ${styles.form_width}`}
              onFinish={onFinish}
              // onFinishFailed={(errorInfo) => {
              //   console.error('Validation Failed:', errorInfo);
              // }}
            >
              <Form.Item
                label={<span className={styles.label}>Mobile</span>}
                name="user_name"
                rules={[
                  { required: true, message: 'Required field' },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: 'Please enter a valid 10-digit mobile number'
                  }
                ]}
              >
                <Input
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Remove non-numeric characters and update the field
                    const numericValue = value.replace(/\D/g, '');

                    form.setFieldsValue({ user_name: numericValue });
                  }}
                  placeholder="Enter your mobile number"
                  className={styles.input}
                />
              </Form.Item>
              <Form.Item
                // label={<span className={styles.label}>OTP</span>}
                label={
                  otpGenerated ? (
                    <span className={styles.label}>OTP</span>
                  ) : null
                }
                name="otp"
                rules={[
                  { required: true, message: 'OTP is required' },
                  {
                    validator: () =>
                      otp.join('').length === 4
                        ? Promise.resolve()
                        : Promise.reject(new Error('OTP must be 4 digits'))
                  }
                ]}
              >
                {otpGenerated ? (
                  <div className={styles.otpContainer}>
                    {otp.map((digit, index) => (
                      <Input
                        key={index}
                        id={`otp-${index}`}
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className={styles.otpInput}
                      />
                    ))}
                  </div>
                ) : (
                  <Button
                    type="primary"
                    loading={otploading}
                    // onClick={generateOTP}
                    onClick={() => {
                      form
                        .validateFields(['user_name'])
                        .then((values) => {
                          generateOTP(values);
                        })
                        .catch((errorInfo) => {
                          console.error('Validation Failed:', errorInfo);
                        });
                    }}
                    className={styles.login_button}
                  >
                    Generate OTP
                  </Button>
                )}
              </Form.Item>
              {otpGenerated ? (
                <Col span={24} xs={24} xl={24} sm={24} md={24} lg={24}>
                  <Button
                    type="link"
                    onClick={() => {
                      form
                        .validateFields(['user_name'])
                        .then((values) => {
                          generateOTP(values);
                        })
                        .catch((errorInfo) => {
                          console.error('Validation Failed:', errorInfo);
                        });
                    }}
                    className="d-block mb-4 sfprotext-medium font-12"
                  >
                    Regenerate OTP?
                  </Button>
                </Col>
              ) : (
                ''
              )}

              {otpGenerated && otp && (
                <>
                  <Row gutter={24} className={styles.remember}>
                    <Col xs={24} xl={24} sm={24} md={24} lg={24}>
                      <FormItem>
                        <CustomButton
                          // block
                          type="primary"
                          htmlType="submit"
                          // loading={loading}
                          loading={
                            loading ? { indicator: customLoader } : false
                          }
                          className={styles.login_button}
                        >
                          Sign in
                        </CustomButton>
                      </FormItem>
                    </Col>
                  </Row>
                </>
              )}
            </Form>
          </div>
        </Col>
      </Row>
      <div>
        {errorMsg && (
          <Message negative>
            <Icon name="warning" />
            {errorMsg}
          </Message>
        )}
      </div>
    </>
  );
};

export default LoginPage;
